// NavbarTooltipTrigger — the house tooltip (brand TitleTooltipTrigger, fed by
// the control's `title`) for a control ON THE NAVBAR. Extend it in place of
// TitleTooltipTrigger beside the button base:
//
//   extends: ['IconButton', 'NavbarTooltipTrigger']
//
// Nika 2026-10-25: "make tooltips smooth and instant … also when its left
// sidebar show tooltips on right and so on". Three props the plugin's
// TooltipTrigger reads at SHOW time (a function-valued custom prop re-runs on
// every read), so each follows the navbar's place as it is now:
//   - `tooltipPlacement`: away from the bar, into the page — under a top bar
//     (as ever), above a bottom bar, right of a left rail, left of a right
//     rail (functions/navbarLayout.js navbarTooltipPlacement);
//   - `tooltipAnchorRect`: on a rail, the rail's outer edge at the control's
//     height (navbarRailRect), so the bubble starts past the rail instead of
//     6px past a glyph that sits inside it; null elsewhere — the control's
//     own box, as ever. A plugin without the prop ignores it;
//   - `tooltipDelay: 0`: the name shows the moment the pointer arrives — the
//     navbar is read by sweeping across it, and the plugin's 250ms first-show
//     delay made every glyph wait.
export const NavbarTooltipTrigger = {
  extends: 'TitleTooltipTrigger',
  tooltipPlacement: (el) => el.call('navbarTooltipPlacement'),
  tooltipAnchorRect: (el) => el.call('navbarRailRect'),
  tooltipDelay: 0
}
